import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function SetResponseCode({ code, noOverride }) {
  return (
    <Route
      render = {({ staticContext }) => {
        if (staticContext && code) {
          if (staticContext.status && noOverride) { return null; }

          staticContext.status = code;
        }

        return null;
      }}
    />
  );
}

SetResponseCode.propTypes = {
  code: PropTypes.number,
  noOverride: PropTypes.bool,
};
